import { gql } from '@apollo/client';

export const fetchInvoicesTotalCountForTransactionAccount = gql`
  query fetchInvoicesTotalCountForTransactionAccount(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: InvoicesFilterOptions
  ) {
    transactionAccount(id: $id) {
      id
      hamsInvoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        nodes {
          id
        }
      }
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
      }
      availablePaymentMethods {
        totalCount
        nodes {
          id
          paymentIssue
          type
          default
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
              cardHolderName
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
              payOnStatement
            }
            totalCreditLimit
            paymentMethod
          }
          ... on PayPal {
            payPal {
              name
              email
            }
          }
          ... on Ach {
            ach {
              bankName
              last4
            }
          }
        }
      }
    }
  }
`;
